import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	header: {
		id: 'eoc.ops-reports-common.sidebar.header',
		defaultMessage: 'Reports',
		description: 'Header text',
	},
	underMaintenance: {
		id: 'eoc.ops-reports-common.sidebar.under-maintenance',
		defaultMessage: 'Reports aren’t available at this time',
		description: 'Text when reports are under maintenance',
	},
	errorIconLabel: {
		id: 'eoc.ops-reports-common.sidebar.error',
		defaultMessage: 'Reports aren’t available at this time',
		description: 'Text label for error icon',
	},
});

export default messages;
